import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getEnvVariables } from '../../helpers/getEnvVariables';
const { REACT_APP_URL } = getEnvVariables();

export const storiesApi = createApi({
    reducerPath: 'stories',
    baseQuery: fetchBaseQuery({ baseUrl: REACT_APP_URL }),
    endpoints: (builder) => ({
        getStories: builder.query({
            query: () => 'stories-all',
            keepUnusedDataFor: 600,
        }),
    }),
});

export const { useGetStoriesQuery } = storiesApi;